// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoPlayer_root__3afWk","video":"VideoPlayer_video__1nOz1"};